exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-hide {\n  margin: 0.5em 0 0.5em 0;\n}\n\n.hidden {\n  display: none;\n}\n\n.margin {\n  color: green !important;\n  font-weight: bold !important;\n}\n\n.history-table {\n  margin-top: 1em;\n}\n\n.history-table h4 {\n  padding-left: 1em;\n}\n\nth {\n  font-weight: bold !important;\n  text-align: center !important;\n}\n\ntd {\n  text-align: center !important;\n}\n.yellow-bg {\n  background: #f4ee9ffd !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/transport-history/history-table/history-table.component.css
// module id = ../../../../../src/app/_components/transport-history/history-table/history-table.component.css
// module chunks = main